module.exports = __webpack_public_path__ + "img/vvip-birthday.3433ebe2.webp";